<template>
    <va-create-layout>
        <DebtRecoveryEvent-form
            :title="title"
            :item="item"
        ></DebtRecoveryEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
